import React from "react";
import type { SaleRecord } from "../../types/sales";

interface Props {
  sales: SaleRecord[];
  onViewAll?: () => void;
}

const RecentSalesTable: React.FC<Props> = ({
  sales,
  onViewAll,
}) => {

  return (
    <div className="rounded-xl bg-white/80 border p-4 shadow-sm overflow-x-auto">
      {/* Header */}
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-lg font-bold text-primary">Sales</h3>

        {onViewAll && (
          <button
            onClick={onViewAll}
            className="text-sm text-primary hover:underline"
          >
            View full sales history
          </button>
        )}
      </div>

      {/* Table */}
      <table className="w-full text-sm min-w-[500px]">
        <thead className="text-blue-900 border-b">
          <tr>
            <th className="text-left py-2">Store</th>
            <th className="text-left py-2">Amount</th>
            <th className="text-left py-2">Payment Method</th>
            <th className="text-left py-2">Date</th>
          </tr>
        </thead>

        <tbody>
          {sales.length === 0 ? (
            <tr>
              <td colSpan={4} className="py-6 text-center text-gray-500">
                No sales recorded for this period
              </td>
            </tr>
          ) : (
            sales.map((sale) => (
              <tr
                key={sale.id}
                className="border-b last:border-none hover:bg-gray-50 transition"
              >
                <td className="py-2">
                  {sale.store}
                </td>
  
                <td className="py-2 font-medium">
                  GHS {sale.amount.toLocaleString()}
                </td>
  
                <td className="py-2">
                  <span className="px-2 py-1 rounded-md bg-blue-50 text-blue-700 text-xs">
                    {sale.paymentMethod}
                  </span>
                </td>
  
                <td className="py-2 text-gray-500">
                  {new Date(sale.createdAt).toDateString()}
                </td>
              </tr>
            ))
          )}

        </tbody>
      </table>
    </div>
  );
};

export default RecentSalesTable;
